<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle"><i class="material-icons cusIconSize">&#xE897;</i><span>Manage Policy</span></p>
      </div>

      <!-- Add Edit form -->
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Proctor Alert Configuration</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>
          <form class="example-form" [formGroup]="form">
            <div class="col s12 m12 l12 ">
              <ul class="mngplcyList">
                <li>
                  <div class="errorZoneSec">
                    <div class="mngPlcyDaysSec example-full-width">
                      <label class="mngplcyListHdng">Maximum Inactive Time</label>
                      <custom-time-control class="proctor-alert" [isDisable]="disableField" formControlName="maxInactiveTime"></custom-time-control>
                      <p class="validate" *ngIf="form.controls.maxInactiveTime.touched && form.controls.maxInactiveTime.invalid">Required Field: Please enter a valid value.</p>
                    </div>
                  </div>
                </li>
                <li class="enhanceWidthSix">
                  
                    <div class="mngPlcyDaysSec example-full-width">
                        <div class="errorZoneSec">
                      <md-form-field>
                        <input mdInput type="text" placeholder="Maximum number of active sessions needing attention" formControlName="maxActiveSession"  maxlength="4">
                      </md-form-field>
                      <p requiredField *ngIf="form.controls.maxActiveSession.touched && form.controls.maxActiveSession.errors && form.controls.maxActiveSession.errors.required">Required Field: Please enter a valid value.</p>
                      <p class="validate" *ngIf="form.controls.maxActiveSession.touched && form.controls.maxActiveSession.value && form.controls.maxActiveSession.errors && form.controls.maxActiveSession.errors.pattern">Only Numbers are allowed</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </form>
        </md-card-content>

        <div class="col s12 m12 l12">
          <md-card-actions>
            <div class="button-row">
              <button [disabled]="form.invalid || isSaveDisable" md-raised-button class="glbAdminBtnCls1" (click)="onSaveForm()">
                  <img src="./assets/images/saveBtnIcon.png" alt="">SAVE</button>
              <button [disabled]="!isSaveDisable" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">
                  <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
            </div>
          </md-card-actions>
        </div>
      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-alert-config/adm-manage-proctor-alert-config.component.html